module.exports = __webpack_public_path__ + "img/favicon_logo.2e46ca4b.png";